import { ViewController, NavParams, ToastController } from 'ionic-angular';
import { Component, NgZone } from '@angular/core';
import { WebSiteUsersService } from '../../providers/webSiteUsers/webSiteUsers.service';
@Component({
  selector: 'add-address',
  templateUrl: 'add-address.component.html'
})
export class AddAddressComponent {
  address: any = {
    "id": "",
    "streetNumber": "",
    "streetName": "",
    "postalCode": "",
    "city": "",
    "address": "",
    "complementAddress": "",
    "inputCode": "",
    "building": "",
    "staircase": "",
    "floor": "",
    "intercom": "",
    "door": "",
    "country": "France",
  };
  language = localStorage.getItem('language');
  addressErreur = {
    streetNumber: false,
    streetName: false,
    postalCode: false,
    city: false
  }
  constructor(private zone: NgZone,
    private ctrView : ViewController,
    private navParams : NavParams,
    private webSiteUsersService: WebSiteUsersService,
    private toastCtrl : ToastController
    ) {
      if(this.navParams.get('address')){
        this.address = this.navParams.get('address');
      }
     }

  getAddress(place: any) {
    this.zone.run(() => {
      this.address.address = place.formatted_address;
      place.address_components.forEach(el => {
        if (el.types.indexOf("locality") > -1) {
          this.address.city = el.long_name;
        }
        if (el.types.indexOf("postal_code") > -1) {
          this.address.postalCode = el.long_name;
        }
        if (el.types.indexOf("street_number") > -1) {
          this.address.streetNumber = el.long_name;
        }
        if (el.types.indexOf("route") > -1) {
          this.address.streetName = el.long_name;
        }
      });
    })
  }
  validate() {
    this.addressErreur.streetNumber = false;
    this.addressErreur.streetName = false;
    this.addressErreur.postalCode = false;
    this.addressErreur.city = false;
    let error = 0;
    if (!this.address.streetNumber || this.address.streetNumber.trim() == "") {
      this.addressErreur.streetNumber = true;
      error++;
    }
    if (!this.address.streetName || this.address.streetName.trim() == "") {
      this.addressErreur.streetName = true;
      error++;
    }
    if (!this.address.postalCode || this.address.postalCode.trim() == "") {
      this.addressErreur.postalCode = true;
      error++;
    }
    if (!this.address.city || this.address.city.trim() == "") {
      this.addressErreur.city = true;
      error++;
    }
    if (error == 0) {
      if (this.address.id) {
        this.webSiteUsersService.updateAddress(this.address).subscribe(
          (data: any) => {
            if (data.code == 200) {
              this.ctrView.dismiss();
            }
          }
        )
      } else {
        this.webSiteUsersService.addAddress(this.address).subscribe(
          (data: any) => {
            this.address.id = data.id;
            // this.modalService.setDismissReason(this.address);
            this.ctrView.dismiss(this.address);
          }
        )
      }

    }else{
      if(this.language == 'eng'){
        this.displayMessage('Please fill in the required fields')
      }else{
        this.displayMessage('Veuillez remplir les champs obligatoires')
      }
    }
  }
  displayMessage(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
  cancel(){
    this. address = {};
    this.ctrView.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/add-address/add-address.component.ts